import * as React from "react";

interface IThankYouSvgProps {
	width: string;
	height: string;
}

export function ThankYouSvg(props: IThankYouSvgProps): JSX.Element {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			id="Group_3263"
			width={props.width}
			height={props.height}
			viewBox={`0 0 ${props.width} ${props.height}`}
		>
			<rect id="Rectangle_986" width="125" height="125" fill="#fef7f2" rx="62.5" />
			<g id="Namaste" transform="translate(41.164 35.382)">
				<g id="Group_3262" transform="translate(-.999)">
					<path
						id="Path_1767"
						d="M1.37 44.893a1.359 1.359 0 0 1-1.151-.645A1.431 1.431 0 0 1 .1 42.959l3.05-7.443 1.35-10.61a13.429 13.429 0 0 1 1.465-4.571l9.963-18.4A3.577 3.577 0 0 1 19.112 0h.038a3.819 3.819 0 0 1 2.227.82A3.257 3.257 0 0 1 23.54 0h.06a3.7 3.7 0 0 1 3.223 1.937l9.963 18.4a12.983 12.983 0 0 1 1.464 4.571l1.35 10.608 3.048 7.443a1.4 1.4 0 0 1-1.29 1.934H29a1.4 1.4 0 0 1-1.29-.879l-3.11-7.326a13.857 13.857 0 0 1-3.281-4.337 13.015 13.015 0 0 1-3.282 4.337l-2.989 7.326a1.4 1.4 0 0 1-1.289.879H1.37zm4.066-7.677L3.443 42.08h9.378l1.993-4.864H5.436zm22.5 0l1.993 4.864h9.377l-1.993-4.864H27.94zm-8.783-34.3a.876.876 0 0 0-.714.369l-9.963 18.4a9.855 9.855 0 0 0-1.167 3.575l-1.172 9.2h10.2a10.983 10.983 0 0 0 3.691-8.146v-7.97h-.469a.884.884 0 0 0-.82.586L16.1 26.667a1.39 1.39 0 0 1-2.637-.879l2.637-7.731a3.667 3.667 0 0 1 3.457-2.457h.469V3.7a.874.874 0 0 0-.868-.779zm3.63 15.484v7.972a10.667 10.667 0 0 0 3.633 8.085h10.256l-1.173-9.2a11.125 11.125 0 0 0-1.172-3.575l-9.963-18.4a.874.874 0 0 0-1.582.41v11.955h.469a3.67 3.67 0 0 1 3.459 2.462l2.637 7.735a1.39 1.39 0 0 1-2.637.879l-2.637-7.736a.886.886 0 0 0-.82-.586z"
						fill="#f5690f"
						transform="translate(.999 10.783)"
					/>
					<path
						id="Path_1768"
						d="M1.758 7.209A1.763 1.763 0 0 0 3.516 5.45V1.758a1.758 1.758 0 0 0-3.516 0v3.751a1.752 1.752 0 0 0 1.758 1.7z"
						fill="#174082"
						transform="translate(20.618)"
					/>
					<path
						id="Path_1769"
						d="M3.146 5.626a1.741 1.741 0 1 0 2.461-2.461L2.966.527a1.7 1.7 0 0 0-2.461 0 1.751 1.751 0 0 0 0 2.461z"
						fill="#174082"
						transform="translate(12.608 3.341)"
					/>
					<path
						id="Path_1770"
						d="M1.758 6.135a1.687 1.687 0 0 0 1.231-.527l2.637-2.642a1.7 1.7 0 0 0 0-2.461 1.751 1.751 0 0 0-2.461 0L.527 3.146a1.7 1.7 0 0 0 0 2.461 1.787 1.787 0 0 0 1.231.528z"
						fill="#174082"
						transform="translate(26.01 3.359)"
					/>
				</g>
			</g>
		</svg>
	);
}
export default ThankYouSvg;
